/**
 * @file index.tsx
 * @module app/modules/my-team/index
 * @description Implements the index workflow for customer-service team management.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Outlet, Route, Routes } from "react-router-dom";
import MyTeam from "./my-team";
import MemberDetails from "./member-details";
const MyTeamIndex = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route index element={<MyTeam />} />
      <Route
        path="/member-details"
        element={
          <>
            <MemberDetails />
          </>
        }
      />
    </Route>
  </Routes>
);
export default MyTeamIndex;
